import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useDispatch } from "react-redux";
import { getAllBookings } from "../../redux/AdminReducer";
import Swal from "sweetalert2";

import { RiDeleteBin6Line } from "react-icons/ri";
import moment from "moment";
import EditVehicleDrawer from "../EditVehicleDrawer/EditVehicleDrawer";
import { useState } from "react";
import { useEffect } from "react";
import { getAllVehicles } from "../../redux/AdminReducer";
import { useSelector } from "react-redux";
import { deleteVehicle } from "../../redux/AdminReducer";
import EditDriverDrawer from "../EditDriverDrawer/EditDriverDrawer";
import { getAllDrivers } from "../../redux/AdminReducer";
import { deleteDriver } from "../../redux/AdminReducer";
import { getCustomers } from "../../redux/AdminReducer";
export default function BookingsAdmin() {
  const [deleteVeh, setDeleteVeh] = useState(0);

  const dispatch = useDispatch();
  const [alertIndex, setAlertIndex] = useState();

  const vehicleData = useSelector(
    (state) => state?.AdminReducer?.allVehiclesData
  );
  const driversData = useSelector(
    (state) => state?.AdminReducer?.getAllDriversData
  );
  const customerData = useSelector(
    (state) => state?.AdminReducer?.getCustomersData
  );
  const getAllBookingsData = useSelector(
    (state) => state?.AdminReducer?.getAllBookingsData
  );

  console.log("vehicleData", vehicleData);

  const deleteIconClicked = (index) => {
    setAlertIndex(index);

    setDeleteVeh(1);
  };

  const noClickedAlert = () => {
    setDeleteVeh(2);
  };

  useEffect(() => {
    // dispatch(getAllDrivers());
    // dispatch(getCustomers());
    dispatch(getAllBookings());
  }, []);

  const yesDeleteClicked = async (data) => {
    let id = data._id;

    const response = await dispatch(deleteDriver({ id, driversData }));

    console.log("responseDeletedVehicle", data);

    setDeleteVeh(2);
  };

  console.log("getAllBookingsData", getAllBookingsData);

  return (
    <div>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell> <TableCell>Email</TableCell>{" "}
              <TableCell>Phone</TableCell>
              <TableCell>Departure Location</TableCell>
              <TableCell align="right">Arrival Location</TableCell>
              <TableCell align="right">Booking Amount</TableCell>
              <TableCell align="right">Pickup Date & Time</TableCell>
              <TableCell align="right">Return PickUp Date & Time</TableCell>
              <TableCell align="right">Hourly Duration</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {getAllBookingsData?.map((item, index) => (
              <TableRow
                key={item?.name}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="right">{item?.name}</TableCell>{" "}
                <TableCell align="right">{item?.email}</TableCell>{" "}
                <TableCell align="right">{item?.phone}</TableCell>
                <TableCell align="right">{item?.pickUpLocation}</TableCell>
                <TableCell align="right">{item?.arrivalLocation}</TableCell>
                <TableCell align="right">
                  {parseInt(item?.bookingAmount)}
                </TableCell>
                {!item.hourlyDuration && (
                  <TableCell align="right">
                    {moment(item?.pickUpDatemoment).format("YYYY-MM-DD")}-
                    {item?.pickUpTime}
                  </TableCell>
                )}
                {item.hourlyDuration && (
                  <TableCell align="right">{item.pickUpTime}</TableCell>
                )}
                {item.hourlyDuration && (
                  <TableCell align="right">{item?.returnPickUpTime}</TableCell>
                )}
                {!item.hourlyDuration && (
                  <TableCell align="right">
                    {moment(item?.returnPickUpDatemoment).format("YYYY-MM-DD")}-
                    {item?.returnPickUpTime}
                  </TableCell>
                )}
                <TableCell align="right">{item?.hourlyDuration}</TableCell>
                {/* <TableCell align="right">{}</TableCell> */}
                {/* <TableCell align="right">
                  <RiDeleteBin6Line
                    onClick={() => deleteIconClicked(index)}
                    className="deleteVehicleIcon"
                  />
                </TableCell> */}
                {/* <TableCell align="right" className="editColDataVeh">
                  <FiEdit2/>

                  <EditVehicleDrawer data={row}/>

                  <EditDriverDrawer data={row}/>
                </TableCell> */}
                {deleteVeh === 1 && alertIndex === index && (
                  <div className="mainDeleteCardVehicle">
                    <div className="confirmTxtAlertVehDlt">
                      {" "}
                      You want to delete Vehicle?
                    </div>
                    <div className="topConfirmBtnDeltVeh">
                      <div
                        className="noBtnAlertDltVeh"
                        onClick={noClickedAlert}
                      >
                        No
                      </div>
                      <div
                        className="yesBtnAlertDltVeh"
                        // onClick={() => yesDeleteClicked(row)}
                      >
                        Yes
                      </div>
                    </div>
                  </div>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
